import script from "./SuggestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionList.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionList.vue?vue&type=style&index=0&id=463497b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463497b4"]])

export default __exports__